import {hashHistory, dispatch} from 'react-router';
import {submit, change} from 'redux-form';

import {
  CUSTOMERS_INFO_REQUEST, CUSTOMERS_INFO_SUCCESS,
  CUSTOMERS_INFO_UPDATE_REQUEST, CUSTOMERS_INFO_UPDATE_SUCCESS, CUSTOMERS_INFO_CLEAR,
  CUSTOMERS_INFO_SET_HEADER_TEXT, CUSTOMERS_SET_LOGO_FILE,
  USER_ENTITY_SET_GOOGLE_CALENDAR
} from '../../constants/actionTypes';
import {getApiConfig} from '../../utilities/index';
import {POPUP_IN_PROGRESS} from '../../constants/actionTypes';
import {
  authGoogleCalendar,
  getFabricatorFromState,
  updateFabricatorTransientField,
  messageBox_Show,
  loadingDialog_show
} from '../../actions';
import customEvent from "../../utilities/customEvent";

export const ActionTypes = {
  SHOW_ESIGNATURE_OVERLAY: 'addNewEntity/SHOW_ESIGNATURE_OVERLAY',
  SET_SUBSCRIPTION_ID: 'addNewEntity/SET_SUBSCRIPTION_ID',
  PAYMENT_GATEWAYS_LOADED: 'addNewEntity/PAYMENT_GATEWAYS_LOADED',
  MANUFACTURER_FILTERS_LOADED: 'addNewEntity/MANUFACTURER_FILTERS_LOADED',
  SUBMID_DATA_LOADED: 'addNewEntity/SUBMID_DATA_LOADED',
  PAYMENT_GATEWAYS_SAVED: 'addNewEntity/PAYMENT_GATEWAYS_SAVED',
  MANUFACTURER_FILTERS_SAVED: 'addNewEntity/MANUFACTURER_FILTERS_SAVED',
  SUB_MID_ID_CREATED: 'addNewEntity/SUB_MID_ID_CREATED',
  SHOW_FINGER_SIGNATURE_OVERLAY: 'addNewEntity/SHOW_FINGER_SIGNATURE_OVERLAY'
}

const {post} = getApiConfig('Users/UpdateCustomerInfo');

export const setSubscriptionId = (type, sub) => {
  return {
    type: ActionTypes.SET_SUBSCRIPTION_ID,
    payload: {type, sub}
  }
}

export const showESignatureOverlay = show => {
  return {
    type: ActionTypes.SHOW_ESIGNATURE_OVERLAY,
    payload: {show}
  }
}

export const showFingerSignatureSetupOverlay = show => {
  return {
    type: ActionTypes.SHOW_FINGER_SIGNATURE_OVERLAY,
    payload: {show}
  }
}

export const getCustomerInfo = (customerId = '', clientType, clientSubType, withLoader = true) => {

  return (dispatch, getState) => {

    if (!customerId) {
      const state = getState();
      const {auth, asCustomer} = state;
      customerId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    }

    if (withLoader) {
      dispatch(loadingDialog_show(true, 'Loading...', 'Please wait while customer data is loaded'));
    }

    dispatch(getCustomersInfoRequest());

    const {get} = getApiConfig(`Users/GetCustomerInfo/${customerId}/${clientType}/${clientSubType}`);

    return get()
      .then(data => {
        dispatch(getCustomersInfoSuccess(data))
        if (withLoader) {
          dispatch(loadingDialog_show(false));
        }
        return data
      })
  }
}

export const getSubscriptions = () => {
  const {get} = getApiConfig(`Users/GetSubscriptions`);
  return dispatch => {
    dispatch(getCustomersInfoRequest());
    get()
      .then(data => {
        dispatch(getCustomersInfoSuccess({subscriptions: data}))
      });
  }
}

export const updateCustomerInfo = (customerInfo) => {
  return dispatch => {
    dispatch({type: CUSTOMERS_INFO_UPDATE_REQUEST});

    post(customerInfo)
      .then(data => {

        dispatch({
          type: CUSTOMERS_INFO_UPDATE_SUCCESS,
          payload: {
            customerInfo,
            __error__: data.__error__
          }
        })
      })
  }
}

export const clearInitialValues = () => {
  return {
    type: CUSTOMERS_INFO_CLEAR
  }
}

export const getCustomersInfoRequest = () => {
  return {
    type: CUSTOMERS_INFO_REQUEST
  }
}

export const getCustomersInfoSuccess = (customerInfo) => {
  return {
    type: CUSTOMERS_INFO_SUCCESS,
    customerInfo
  }
}

export const setHeaderText = (headerText) => {
  return {
    type: CUSTOMERS_INFO_SET_HEADER_TEXT,
    headerText
  }
}

export const showSavingProgress = () => {
  return {
    type: POPUP_IN_PROGRESS,
    payload: {
      show: true,
      title: 'Saving New Data',
      message: 'Please wait ...'
    }
  }
}

export const _authGoogleCalendar = (entityId) => {
  return (dispatch, getState) =>
    authGoogleCalendar()(dispatch, getState)
      .then((response) => {
        const {access_token, client_id, expires_at, expires_in, issued_at, response_type, scope, token_type} = response.result;
        let result = JSON.stringify({
          access_token,
          client_id,
          expires_at,
          expires_in,
          issued_at,
          response_type,
          scope,
          token_type
        });

        // set the value in the forms fields
        dispatch(change('newEntity', 'authValues', result));
      })
      .catch((response) => {
        console.log(999, "GCal", response);
        dispatch(messageBox_Show(true, 'error', 'An error occurred', 'Unable to authorize Google Calendar Access.'));
      })
}

export const loadManufacturerFilters = () => {
  return (dispatch) => {
    const { get } = getApiConfig('Filters/GetManufacturerFilterGroupValues');
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading Manufacturer Filters...'));
    return get()
      .then(response => {
        dispatch({
          type: ActionTypes.MANUFACTURER_FILTERS_LOADED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}

export const saveManufacturerFilters = (model) => {
  return (dispatch) => {
    const {post} = getApiConfig('Filters/manufacturer');
    dispatch(loadingDialog_show(true, 'Saving...', 'Saving Manufacturer Filters...'));
    return post(model)
      .then(response => {
        dispatch({
          type: ActionTypes.MANUFACTURER_FILTERS_SAVED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}

export const loadPaymentGateways = (fabricatorId) => {
  return (dispatch) => {
    const { get } = getApiConfig('Dashboard_PaymentGateways/List?fabricatorId=' + fabricatorId);
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading Payment Gateways...'));
    return get()
      .then(response => {
        dispatch({
          type: ActionTypes.PAYMENT_GATEWAYS_LOADED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}

export const savePaymentGateways = (model) => {
  return (dispatch) => {
    const {post} = getApiConfig('Dashboard_PaymentGateways/Save');
    dispatch(loadingDialog_show(true, 'Saving...', 'Saving Payment Gateways...'));
    return post(model)
      .then(response => {
        dispatch({
          type: ActionTypes.PAYMENT_GATEWAYS_SAVED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}

export const loadSubMidData = (fabricatorId) => {
  return (dispatch) => {
    const { get } = getApiConfig('Dashboard_PaymentGateways/GetSubMidData?fabricatorId=' + fabricatorId);
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading Sub Mid Data...'));
    return get()
      .then(response => {
        dispatch({
          type: ActionTypes.SUBMID_DATA_LOADED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}


export const createFabricatorSubMidId = (fabricatorId, model) => {
  return (dispatch) => {
    const {post} = getApiConfig(`Dashboard_PaymentGateways`);
    dispatch(loadingDialog_show(true, 'Sub Mid...', 'Creating Sub Mid Id...'));
    return post(model, `CreateSubMidId?fabricatorId=${fabricatorId}`)
      .then(response => {
        dispatch({
          type: ActionTypes.SUB_MID_ID_CREATED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        return response;
      });
  }
}

export const showSuccessPopup = () => {
  return {
    type: POPUP_IN_PROGRESS,
    payload: {
      show: false
    }
  }
}

export const handleFooterCancel = (props) => {
  if(props.showESignatureOverlay) {
    props.dispatch(showESignatureOverlay(false));
    document.dispatchEvent(customEvent('cancel-esignature-overlay'));
  }
  else {
    hashHistory.push('/');
  }
}

/// initializes html-Form to submit, this will make redux-form to call AddNewEntity.handleSave via onSubmit event
export const handleFooterSave = (props) => {
  console.log('Submit new entity form');
  props.dispatch(submit('newEntity'));
}

export const handleSetLogoFile = logoFile => ({type: CUSTOMERS_SET_LOGO_FILE, payload: logoFile});
